var _path, _path2, _path3, _rect, _circle, _circle2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArtInformation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.622-58.698-60.688 1.531-27.357 38.565-27.82 64.193-37.513Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M150.257 145.257 138 133h33l-12.257 12.257a6 6 0 0 1-8.486 0Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 124,
  height: 85,
  x: 92,
  y: 48,
  fill: "#3863F0",
  rx: 12
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 91,
  r: 26,
  fill: "#fff"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 104,
  r: 4,
  fill: "#3863F0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3863F0",
  strokeLinecap: "round",
  strokeWidth: 8,
  d: "M154 76v17"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#223B90",
  fillRule: "evenodd",
  d: "M123 30c-6.627 0-12 5.373-12 12h100c6.627 0 12 5.373 12 12v61c6.627 0 12-5.373 12-12V42c0-6.627-5.373-12-12-12H123Z",
  clipRule: "evenodd"
})));
export default SvgArtInformation;